<template>
  <a
    @click="$emit('showShare')"
    class="tab-trigger-btn text-link font-bold"
    :class="{ 'tab-trigger-btn--active': isShowShareTab }"
  >
    <aha-icon
      class="mr-0 xl:mr-1"
      name="share"
      viewBox="0 0 20 20"
      width="20"
      height="20"
    />
    <span class="xl:block font-bold">{{ $i18nPresenter.t('Share') }}</span>
  </a>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    isShowShareTab() {
      return this.presentation.id && this.presentation.showShare
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-trigger-btn {
  @apply relative top-2 items-center px-1.5 xl:px-2 pt-2 pb-6;
  @apply md:flex;
  // only apply transition to color. Prevent wierd background flicker when applying --active class
  transition-property: color;

  &--active {
    @apply z-20 rounded-t-md text-primary-100;
    &:not(.share-v2){
      @apply bg-base-0
    }
  }
}
</style>
